import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import { useTheme } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useCallback } from 'react'
import { useParams } from 'react-router-dom'

import { i18WithDefault as t } from '@shared/locale'
import { DateSelector } from './date_selector'
import { RoomsAndPets } from './rooms_and_pets'
import { useBookingContext } from '@providers/booking'
import { useRoutes } from 'app/use_routes'

export const SearchBar = () => {
  const theme = useTheme()
  const bookingCtx = useBookingContext()
  const { serviceTypeName = '' } = useParams()
  const { navigateRoute } = useRoutes()
  const isBelowMD = useMediaQuery(theme.breakpoints.down('md'))

  const doSearch = useCallback(() => {
    bookingCtx.dispatch({ type: 'SET_SEARCH_STATE', payload: { value: 'searchResults' } })
    navigateRoute('searchOffersResults', { serviceTypeName: serviceTypeName })
  }, [bookingCtx, navigateRoute, serviceTypeName])

  return (
    <Box sx={{ maxWidth: '900px', margin: '0 auto' }}>
      <Paper elevation={1} sx={{ pt: 1, pb: 2, px: 4, borderRadius: `${isBelowMD ? 0 : theme.shape.borderRadius}px` }}>
        <Stack direction={{ sm: 'column', md: 'row' }} spacing={2}>
          {serviceTypeName !== 'daycare' && (
            <>
              <DateSelector />
              {isBelowMD ? (
                <Divider orientation="horizontal" flexItem sx={{ pt: 1, mb: 1 }} />
              ) : (
                <Divider orientation="vertical" flexItem />
              )}
            </>
          )}
          <RoomsAndPets />
          <Stack
            direction="column"
            alignItems={{ xs: 'start', md: 'end' }}
            justifyContent="center"
            sx={{ marginRight: 'auto', flexShrink: 1, mt: { xs: 2, md: 0 } }}
          >
            <Button size="large" variant="contained" disabled={!bookingCtx.state.isValid} onClick={doSearch}>
              {t('global.label.Search')}
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Box>
  )
}
